var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPregnancyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 73.994,
    viewBox: "0 0 64 73.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M32-16A32,32,0,0,0,64-48,32,32,0,0,0,32-80,32,32,0,0,0,0-48,32,32,0,0,0,32-16Z",
    fill: "#e3e5f5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M-1083,262.2H69V-557H-1083Z",
    transform: "translate(1083 557)",
    fill: "#e3e5f5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    transform: "translate(-872 -2575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_994",
    "data-name": "Group 994",
    transform: "translate(872 2660)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_993",
    "data-name": "Group 993",
    transform: "translate(-866.4 -461.6)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M-5-85H67v72H-5Z",
    transform: "translate(867.4 462.6)",
    fill: "#e3e5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_992",
    "data-name": "Group 992",
    transform: "translate(571.905 1828.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "HEAD",
    d: "M368.922,773.962c.036,3.245.529,10.013,2.282,10.054l.557.01h0c.049,0,.1,0,.157,0,.765.011,1.354.008,1.723,0a.007.007,0,0,0,.005,0c.283,0,.434-.006.434-.006l1.27,2.849,2.2,4.93.38-.625v0c.745-1.221,1.606-1.954,2.077-2.7a13.89,13.89,0,0,1-1.255-4.55c-.123-2.311.208-5.47-3.085-5.879A8.654,8.654,0,0,1,368.922,773.962Z",
    transform: "translate(-43.311 -21.921)",
    fill: "#8E97D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M337.9,889.8v-4.506a6.914,6.914,0,0,1,.786-3.2l4.376-7.4a9.719,9.719,0,0,0,1.107-8.155l-3.389-8.812a6.915,6.915,0,0,1-.274-4.081l2.556-10.763a6.915,6.915,0,0,0-2.163-6.793l-.505-.444A6.915,6.915,0,0,0,333,834.522h0a6.916,6.916,0,0,0-3.186,2.9l-6.094,10.745a6.876,6.876,0,0,1-1.953,2.184c-2.6,1.88-7.991,4.976-6.657,13.646.871,5.664,4.089,7.369,7.407,9.416,3,.719,3.912,4.614,4.044,7.7l.36,8.4",
    transform: "translate(0 -69.477)",
    fill: "#8E97D6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M344.977,960.495l-4.036-6.006-1.155-1.719a2.925,2.925,0,0,1,2.238-4.564c.05,0,.1,0,.15,0a3.257,3.257,0,0,1,2.742,1.494l.065.109.057-.109a3.257,3.257,0,0,1,2.743-1.494q.075,0,.15,0a2.925,2.925,0,0,1,2.238,4.564l-1.155,1.719-4.035,6.006Z",
    transform: "translate(-20.579 -160.907)",
    fill: "#d2d5ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "HAIR",
    d: "M368.207,751.958q.032.038.065.083a8.654,8.654,0,0,0,6.748,4.086c3.292.409,2.962,3.568,3.085,5.879a11.906,11.906,0,0,0,1.051,4.229c.079.187.163.376.25.567h0c.2.437.417.884.648,1.353q.687,1.4,1.338,2.544c2.436,4.317,4.468,6.124,6.057,6.365a2.435,2.435,0,0,0,.418.026c3.791-.083,7.5-5.684,2.385-13.285-9-13.375-8.284-16.833-12.953-17.392a11.8,11.8,0,0,0-2.4-.047,7.772,7.772,0,0,0-6,3.21,5.906,5.906,0,0,0-.79,1.778A1.249,1.249,0,0,0,368.207,751.958Z",
    transform: "translate(-42.661)",
    fill: "#c1c6e8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPregnancyIcon);
export default __webpack_public_path__ + "static/media/pregnancy-icon.fa979c9b.svg";
export { ForwardRef as ReactComponent };